/* import __COLOCATED_TEMPLATE__ from './tab-button.hbs'; */
import Component from '@glimmer/component';

interface TabButtonArgs {
  type: string;
  activeTab: string;
  enabledTabs: [string];
  onclick: () => void;
}
export default class TabButton extends Component<TabButtonArgs> {
  get isDisabled(): boolean {
    const index = this.args.enabledTabs.findIndex((item) => {
      return item === this.args.activeTab;
    });
    return (
      index === -1 ||
      (this.args.type === 'previous' && index === 0) ||
      (this.args.type === 'next' && index === this.args.enabledTabs.length - 1)
    );
  }

  get toTab(): string | null {
    const index = this.args.enabledTabs.findIndex((item) => {
      return item === this.args.activeTab;
    });
    if (
      index === -1 ||
      (this.args.type === 'previous' && index === 0) ||
      (this.args.type === 'next' && index === this.args.enabledTabs.length - 1)
    ) {
      return null;
    }
    if (this.args.type === 'previous') {
      return this.args.enabledTabs[index - 1] as string;
    }
    if (this.args.type === 'next') {
      return this.args.enabledTabs[index + 1] as string;
    }
    return this.args.enabledTabs[index] as string;
  }
}
